"use strict";
import { __module as r } from "./index.es228.js";
import { __require as o } from "./index.es229.js";
import { __require as t } from "./index.es230.js";
var e;
function i() {
  return e ? r.exports : (e = 1, process.env.NODE_ENV === "production" ? r.exports = o() : r.exports = t(), r.exports);
}
export {
  i as __require
};
//# sourceMappingURL=index.es108.js.map
